import React from "react";
import { List, Tooltip, Popconfirm } from "antd";
import { DeleteFilled, SwapOutlined } from "@ant-design/icons";

function ZipCodeList({ zone, zipCodes, onRemove, onMove }) {
  const isPrimary = zone === 'primary';
  const zoneName = isPrimary ? 'Primary Service' : 'Outside Zone';
  const moveToZone = isPrimary ? 'Outside Zone' : 'Primary Zone';
  const swapColor = isPrimary ? '#faad14' : '#52c41a';

  return (
    <div className="flex flex-col gap-2 w-full items-start">
      <label style={{ fontWeight: "bold", fontSize: "14px" }}>
        {zoneName} Zip Codes ({zipCodes.length})
      </label>
      <List
        size="small"
        bordered
        dataSource={zipCodes}
        locale={{ emptyText: `No ${zoneName.toLowerCase()} zip codes added yet` }}
        className="profile_input_wrapper"
        style={{
          maxHeight: 300,
          overflow: "auto",
          width: "100%",
        }}
        renderItem={(item) => (
          <List.Item 
            key={item}
            actions={[
              <Tooltip title={`Move to ${moveToZone}`}>
                <Popconfirm
                  title={`Move to ${moveToZone}?`}
                  description={`Move ${item} to ${moveToZone.toLowerCase()}?`}
                  onConfirm={() => onMove(item)}
                  okText="Yes"
                  cancelText="No"
                >
                  <SwapOutlined
                    style={{ 
                      color: swapColor, 
                      cursor: "pointer", 
                      fontSize: "16px",
                      marginRight: "12px"
                    }}
                  />
                </Popconfirm>
              </Tooltip>,
              <Tooltip title="Delete">
                <Popconfirm
                  title="Delete Zip Code?"
                  description={`Are you sure you want to delete ${item}?`}
                  onConfirm={() => onRemove(item)}
                  okText="Yes"
                  cancelText="No"
                >
                  <DeleteFilled
                    style={{ 
                      color: "#ff4d4f", 
                      cursor: "pointer", 
                      fontSize: "16px" 
                    }}
                  />
                </Popconfirm>
              </Tooltip>
            ]}
          >
            <List.Item.Meta 
              title={
                <span style={{ fontSize: "14px", fontWeight: "500" }}>
                  {item}
                </span>
              } 
            />
          </List.Item>
        )}
      />
    </div>
  );
}

export default ZipCodeList;